<!-- Dashboard -->
<div class="row">

    <!-- Templates Card -->
    <div class="col-sm-6 col-lg-3">
        <div class="card overflow-hidden">
            <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-7">
                    <div class="p-2 bg-primary-subtle text-primary rounded-circle round-40 d-flex align-items-center justify-content-center">
                        <iconify-icon icon="solar:layers-line-duotone" class="fs-6"></iconify-icon>
                    </div>
                    <span class="badge rounded-pill bg-primary-subtle text-primary border-primary border">Total</span>
                </div>
                <h5 class="fw-bold fs-14 mb-1" id="stat-templates">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </h5>
                <p class="fs-3 mb-0">Templates</p>
            </div>
        </div>
    </div>

    <!-- Packs Card -->
    <div class="col-sm-6 col-lg-3">
        <div class="card overflow-hidden">
            <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-7">
                    <div class="p-2 bg-secondary-subtle text-secondary rounded-circle round-40 d-flex align-items-center justify-content-center">
                        <iconify-icon icon="solar:box-line-duotone" class="fs-6"></iconify-icon>
                    </div>
                    <span class="badge rounded-pill bg-secondary-subtle text-secondary border-secondary border">Total</span>
                </div>
                <h5 class="fw-bold fs-14 mb-1" id="stat-packs">
                    <div class="spinner-border spinner-border-sm text-secondary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </h5>
                <p class="fs-3 mb-0">Packs</p>
            </div>
        </div>
    </div>

    <!-- Generated Documents Card -->
    <div class="col-sm-6 col-lg-3">
        <div class="card overflow-hidden">
            <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-7">
                    <div class="p-2 bg-success-subtle text-success rounded-circle round-40 d-flex align-items-center justify-content-center">
                        <iconify-icon icon="solar:document-text-line-duotone" class="fs-6"></iconify-icon>
                    </div>
                    <span class="badge rounded-pill bg-success-subtle text-success border-success border">Last 90 days</span>
                </div>
                <h5 class="fw-bold fs-14 mb-1" id="stat-documents">
                    <div class="spinner-border spinner-border-sm text-success" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </h5>
                <p class="fs-3 mb-0">Generated Documents</p>
            </div>
        </div>
    </div>

    <!-- Credits Used Card -->
    <div class="col-sm-6 col-lg-3">
        <div class="card overflow-hidden">
            <div class="card-body p-4">
                <div class="d-flex align-items-center justify-content-between mb-7">
                    <div class="p-2 bg-warning-subtle text-warning rounded-circle round-40 d-flex align-items-center justify-content-center">
                        <iconify-icon icon="solar:bolt-circle-line-duotone" class="fs-6"></iconify-icon>
                    </div>
                    <span class="badge rounded-pill bg-warning-subtle text-warning border-warning border" id="stat-credits-badge">
                        <div class="spinner-border spinner-border-sm text-warning" role="status" style="width: 0.7rem; height: 0.7rem;">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </span>
                </div>
                <h5 class="fw-bold fs-14 mb-1" id="stat-credits">
                    <div class="spinner-border spinner-border-sm text-warning" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </h5>
                <p class="fs-3 mb-0">Credits Used This Month</p>
            </div>
        </div>
    </div>

</div>

<!-- Line Chart -->
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="d-flex mb-4 justify-content-between align-items-center">
                    <div>
                        <h4 class="card-title mb-1">Generated Documents</h4>
                        <p class="card-subtitle mb-0">Overview</p>
                    </div>
                    <div class="d-flex align-items-center gap-3">
                        <div class="d-flex align-items-center">
                            <span class="d-inline-block rounded-circle me-1" style="width: 10px; height: 10px; background-color: var(--bs-success);"></span>
                            <span class="fs-3">Success</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="d-inline-block rounded-circle me-1" style="width: 10px; height: 10px; background-color: var(--bs-danger);"></span>
                            <span class="fs-3">Errors</span>
                        </div>
                    </div>
                </div>
                <div id="documents-chart" style="height: 300px;"></div>
            </div>
        </div>
    </div>
</div>
